import { gql } from '@apollo/client';

export const getExposedDocumentation = gql`
  query ExposedDocumentation($creditStudyId: String!) {
    exposedDocumentation(creditStudyId: $creditStudyId) {
      id
      userId
      creditStudyId
      isComplete
      type
      status
      requiredDocuments
      documents {
        id
        documentationId
        type
      }
    }
  }
`;
